var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lottie-wrap"},[_c('lottie-animation',{attrs:{"path":"lottie/v1/data.json","loop":true,"autoPlay":true,"speed":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }